import React from 'react';
import PropTypes from 'prop-types';

import DropdownMenu from '../../../../../../components/global/DropdownMenu';
import Button from '../../../../../../components/global/Button';
import PlusIcon from '../../../../../../components/icons/PlusIcon';
import {
  CUSTOM_MESSAGE_PLACEHOLDERS,
  CUSTOM_MESSAGE_PLACEHOLDER_CONFIG,
} from '../../../../../../constants/custom-messages';

const propTypes = {
  value: PropTypes.string,
  onInsert: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  placeholders: PropTypes.arrayOf(PropTypes.string),
};

// "+ Insert variable" link that drops down the placeholder list. Placeholders
// that only make sense once (the greeting) are disabled when already present.
const InsertVariableDropdown = ({
  value = '',
  onInsert,
  disabled,
  placeholders = CUSTOM_MESSAGE_PLACEHOLDERS,
}) => (
  <div className="dropdown-menu-dark custom-message-insert-variable">
    <DropdownMenu
      placement="bottom-end"
      closeOnClickWithin
      toggle={
        <span className="d-flex align-items-center text-primary text-extra-bold text-sm">
          <PlusIcon size={10} color="#0d84fe" className="mr-1" /> Insert
          variable
        </span>
      }
    >
      {placeholders.map(placeholder => {
        const config = CUSTOM_MESSAGE_PLACEHOLDER_CONFIG[placeholder] ?? {};
        const alreadyUsed =
          !config.allowMultiple && (value ?? '').includes(placeholder);

        return (
          <Button
            key={placeholder}
            btnStyle="reset"
            className="dropdown-item"
            disabled={disabled || alreadyUsed}
            title={config.tooltip}
            onClick={() => onInsert(placeholder, { prepend: !!config.prepend })}
          >
            {config.label ?? placeholder}
          </Button>
        );
      })}
    </DropdownMenu>
  </div>
);

InsertVariableDropdown.propTypes = propTypes;

export default InsertVariableDropdown;
